import { createSlice } from '@reduxjs/toolkit'
import LatLng from 'interfaces/LatLng'

export const MIN_RADIUS = 100
export const MAX_RADIUS = 20000

export interface MapState {
  searchCircle:
    | {
        center: LatLng
        radius: number
      }
    | undefined
  principalBounds: google.maps.LatLngBoundsLiteral | undefined
  zoom: number | undefined
  isStreetViewOpen: boolean
}

const initialState: MapState = {
  searchCircle: undefined,
  principalBounds: undefined,
  zoom: undefined,
  isStreetViewOpen: false,
}

const name = 'map'

const mapSlice = createSlice({
  name,
  initialState,
  reducers: {
    // Redux Toolkit allows us to write "mutating" logic in reducers. It
    // doesn't actually mutate the state because it uses the Immer library,
    // which detects changes to a "draft state" and produces a brand new
    // immutable state based off those changes
    updateSearchCircle: (state, action) => {
      const searchCircle = action.payload

      state.searchCircle = searchCircle
    },
    updateSearchCircleRadius: (state, action) => {
      const radius = action.payload

      if (state.searchCircle) {
        state.searchCircle.radius = radius
      }
    },
    updateSearchCircleCenter: (state, action) => {
      const center = action.payload

      if (state.searchCircle) {
        state.searchCircle.center = center
      }
    },
    updatePrincipalBounds: (state, action) => {
      const principalBounds = action.payload

      state.principalBounds = principalBounds
    },
    updateZoom: (state, action) => {
      const zoom = action.payload
      state.zoom = zoom
    },
    streetViewOpened: (state) => {
      state.isStreetViewOpen = true
    },
    streetViewClosed: (state) => {
      state.isStreetViewOpen = false
    },
  },
})

export const {
  updateSearchCircle,
  updateSearchCircleRadius,
  updateSearchCircleCenter,
  updatePrincipalBounds,
  updateZoom,
  streetViewOpened,
  streetViewClosed,
} = mapSlice.actions

export default mapSlice
